import React from "react";
import Grid from "@material-ui/core/Grid";
import '../../../App.scss';
import BlueButton from "../../../assets/images/img_blue_panel.png";
import WalletCoin from "../../../assets/images/ic_wallet_coin.png";
import VarizBtn from "../../../assets/images/img_btn_variz.png";
import SormeiBackground from "../../../assets/images/img_sormei_wallet.png";

class TransferBotton extends React.Component {
    constructor() {
        super();
        this.state = {
            style: {},
        }
    }
    render() {
        return(
            <Grid alignItems='center' container sm={12} item justify='space-around'
                  className="wallet-transfer-section"
            >
                <img className="wallet-transfer-section-background-image" src={VarizBtn} alt=""/>
                <p className="wallet-transfer-section-text">
                    واریز به حساب
                </p>
                <img className="wallet-transfer-section-icon" src={WalletCoin} alt=""/>

            </Grid>
        )

    }
}
export default  TransferBotton